// src/portal/portalStatus.js
//
// What a status MEANS for the role reading it.
//
// ── THE PILL ALREADY SAYS HALF OF THIS ─────────────────────────────────────
//
// PortalPlanHead renders a status chip — "With the reviewer", "Waiting on you",
// "Changes requested". Every sentence below opens by saying the same thing
// again, and that duplicate clause was costing a full row beneath the header:
//
//   chip:     With the reviewer
//   sentence: With the reviewer. You can still add notes.
//
// So the sentences keep their shape — they are still the one place the state is
// written out in full — and the page renders only the clause the chip cannot
// carry. Splitting rather than rewriting means the table stays readable as
// prose, and the chip and the guidance cannot drift apart into two vocabularies.
//
// Two of the eight have no second clause. "Nothing submitted yet." is complete;
// there is no advice to give, and the chip alone is right.

export const STATUS_SENTENCE = {
  submitter: {
    draft: "Nothing submitted yet.",
    submitted: "With the reviewer. You can still add notes.",
    changes_requested: "The reviewer has asked for changes. Their findings are on the plan below.",
    approved: "Approved. This review is closed.",
  },
  reviewer: {
    draft: "The submitter has not submitted anything yet.",
    submitted: "Waiting on you. Add findings, then return the plan or approve it.",
    changes_requested: "Returned to the submitter. Waiting for a new revision.",
    approved: "Approved. This review is closed.",
  },
};

/**
 * The part of the sentence the status chip does NOT already say.
 *
 * Split at the first sentence break, not by a second table: a second table is a
 * second thing to keep in step with the first, and the whole point is that the
 * chip and this line are two views of one string.
 *
 * @returns {string|null} null when the sentence is a single clause
 */
export function statusGuidance(role, status) {
  const s = STATUS_SENTENCE[role]?.[status];
  if (typeof s !== "string") return null;
  const i = s.indexOf(". ");
  return i === -1 ? null : s.slice(i + 2).trim() || null;
}
